
import { Component, Prop, Vue } from "vue-property-decorator";

import Card from "@/components/card/Card.vue";
import RatingStars from "@/components/rating/RatingStars.vue";
import CardInfoChip from "@/components/card/CardInfoChip.vue";
import UIButton from "@/components/button/ui-button.vue";
import DeleteReviewButton from "@/components/rating/DeleteReviewButton.vue";
import ReviewModal from "@/components/rating/ReviewModal.vue";
import { hslColorFromName } from "@/utils/hslColorFromName";
import { Contractor_Rating } from "@/generated/graphql";
import Roles from "@/entities/Roles";
import RouteNames from "@/entities/RouteNames";
import RouteParams from "@/entities/RouteParams";
import BadgeColor from "@/entities/BadgeColor";
import Badge from "@/components/common/Badge.vue";
import CardBodySingleChip from "@/components/card/CardBodySingleChipNew.vue";

@Component({
  components: {
    CardBodySingleChip,
    Card,
    RatingStars,
    CardInfoChip,
    UIButton,
    DeleteReviewButton,
    ReviewModal,
    Badge,
  },
})
export default class ContractorReviewNew extends Vue {
  @Prop({ type: String, required: true }) readonly contractorId!: string;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, required: true }) readonly currentUserRole!: string;
  @Prop({ type: Object, required: true }) readonly rating!: Contractor_Rating;
  @Prop({ type: Boolean, default: false }) readonly actionsHidden!: boolean;

  dialog: boolean = false;
  editted: boolean = false;
  badgeColor: typeof BadgeColor = BadgeColor;

  get reviewerName(): string {
    const {
      reviewer: { given_name, family_name },
    } = this.rating;
    return `${given_name} ${family_name}`;
  }

  get reviewedByMe(): boolean {
    return this.rating.reviewer.id === this.currentUserId;
  }


bgStyle(review): object {
  const words = review.split(' ');
  const initial = words[0];
      return {
        background: hslColorFromName(initial || ""),
      };
    }

  get review(): string {
    return this.rating.review;
  }

  get score(): number {
    return this.rating.score;
  }

  get ratingId(): number {
    return this.rating.id;
  }

  get isEditted(): boolean {
    return this.editted || this.rating.created_at !== this.rating.updated_at;
  }

  get isAdmin(): boolean {
    return this.currentUserRole === Roles.ADMIN;
  }

  handleEditted(): void {
    this.editted = true;
  }

  toggleReviewModal(): void {
    this.dialog = !this.dialog;
  }

  get reviewerRouteParams(): RouteParams<{ id: string }> | undefined {
    if (!this.isEditable) {
      return;
    }

    const managerId = this.rating.reviewer.manager?.id;
    if (!managerId) {
      return undefined;
    }
    return {
      name: RouteNames.MANAGER_ABOUT,
      params: { id: managerId },
    };
  }

  get buttonsShown(): boolean {
    if (this.actionsHidden) {
      return false;
    }

    return this.isEditable;
  }

  get isEditable(): boolean {
    const {
      reviewer: { id: reviewerId },
    } = this.rating;
    return this.isAdmin || reviewerId === this.currentUserId;
  }

  get reviewDate(): string {
    const { created_at: createdAt, updated_at: updatedAt } = this.rating;

    // const description = createdAt === updatedAt ? "Added" : "Last modified";

    return `${this.$moment(String(updatedAt)).format("DD MMMM, YYYY ･ hh:mmA")}`;
  }
}
